import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';

import { FilterCommonProps } from '../types';

export class FilterCheckbox extends React.Component<FilterCommonProps, {}> {

  public render() {
    const { simpleFormComponent: SimpleForm, initialValue, filterDomain: { id: name, label } } = this.props;        
    const text: string = label.split(' - ').pop();
    
    return <SimpleForm
      name={name}
      label={{text}}
      type={FIELD_TYPE.CHECKBOX}
      initialValue={initialValue}
      staticOptions={[{ value: 1 }]}      
    />;
  }
}
